import { render, staticRenderFns } from "./ToothDesigns.vue?vue&type=template&id=36eae350"
import script from "./ToothDesigns.vue?vue&type=script&lang=js"
export * from "./ToothDesigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports